<template>
  <v-card>
    <Cabecera 
      :tipoModuloActual="'scoring'"
      :incrustado="true"
    />
    <v-container fluid>
      <o-base-justify-text>
        <span v-html="getTexto('scoring.bienvenida', codigoPromocion) || $t('reservas.scoring.scoringBienvenido')" />
      </o-base-justify-text>
      <o-big-title >{{$t('reservas.scoring.estudioViabilidad')}}</o-big-title>
      <v-slide-x-transition>
        <ResultadoScoring 
          v-if="mostrarResultadoScoring"
          :compradores.sync="compradores"
          :waitingForLoad="waitingForLoad"
          @terminado="terminar()"
        />
      </v-slide-x-transition>
      <v-slide-x-transition>
      <BaseScoring 
        v-if="!mostrarResultadoScoring"
        :compradores.sync="compradores"
        @terminado="scoringTerminado()"
      />
      </v-slide-x-transition>
    </v-container>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BaseScoring from '@/components/reservas/scoring/BaseScoring'
import ResultadoScoring from '@/components/reservas/scoring/ResultadoScoring'
import rules from '@/mixins/rules'
import Cabecera from '@/components/Cabecera'

export default {
  mixins: [rules],
  data () {
    return {
      waitingForLoad: false,
      compradores: [],
      mostrarResultadoScoring: false
    }
  },
  components: {
    BaseScoring, ResultadoScoring, Cabecera
  },
  computed: {
    ...mapGetters({
      codigoPromocion: 'incrustado/codigoPromocion',
      modulos: 'modulosOrdenes/modulos/getAll',
      codigoActivo: 'incrustado/codigoActivo'
    })
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadInmueble: 'promociones/inmuebles/load',
      comprobarScoring: 'scoring/comprobarScoring'
    }),
    scoringTerminado () {
      this.mostrarResultadoScoring = true
    },
    terminar () {
      this.$emit('terminado')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservas/scoring/Scoring.vue